<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f  u-jsb " :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="activity_title" label="活动名称" show-overfl ow-tooltip> </el-table-column>
                <el-table-column prop="introduction" label="活动简介" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column prop="read_count" label="查看量" show-overflow-tooltip width="80">
                    <template slot-scope="scope">
                        {{scope.row.read_count}} <span class="xq" title="查看详情" @click="openlode(scope.row.id)">详情</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 设置 -->
        <el-dialog title="活动设置" width="80%" :visible.sync="dialoged" @close='closedialo' top="20px" center
            :close-on-click-modal='false' class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-loading='sendacloading'>
                <el-form ref="forms" :model="forms" :rules="rules" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="活动名称" prop="zs_value">
                        <el-input size="small" v-model="forms.zs_value" placeholder="（服务名称）"></el-input>
                    </el-form-item>
                    <el-form-item label="活动简介" prop="brief">
                        <el-input size="small" v-model="forms.brief" type="textarea" :rows="2"
                            placeholder="请输入活动简介（头部简介）">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="活动内容" prop="problem">
                        <tinymce ref="editor" v-model="forms.problem" class="editors"
                            toolbar="undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists table | removeformat | imageUpload" />
                    </el-form-item>
                    <el-form-item label="发送方式" prop="problem">
                        <el-radio v-model="sendradio" :label="2">人员</el-radio>
                        <el-radio v-model="sendradio" :label="1">用户组</el-radio>
                    </el-form-item>

                    <el-form-item :label="sendradio==1?'选择组':'选择人员'">
                        <div class="u-f u-ac">
                            <el-form-item v-if="sendradio!=1">
                                <el-input v-model="userkeyword" placeholder="请输入昵称、手机号" style="width:200px" clearable
                                    size="small"></el-input>
                            </el-form-item>
                            <div class="pd">
                                <el-form-item>
                                    <el-select v-model="lb_value" :clearable='sendradio!=1' placeholder="请选择人员类型"
                                        size="small" filterable>
                                        <el-option v-for="item in  lb_options" :key="item.id" :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-form-item v-if="sendradio==1">
                                <span style="color:red;padding:5px 0;font-size:13px">(选择发送给所属类别人员)</span>
                            </el-form-item>
                            <el-form-item v-if="sendradio!=1">
                                <el-button type="primary" icon="el-icon-search" size="small" @click="searchusers">搜索
                                </el-button>
                                <span style="color:red;padding:5px 0;font-size:13px">(不选则全体活动)</span>
                            </el-form-item>
                        </div>
                        <div v-if="sendradio!=1">
                            <div class="u-f">
                                <div style="width:50%">
                                    <el-table :data="userTableData" border v-loading="false" height="430px"
                                        ref="configurationTables" @selection-change="handleSelectionChange"
                                        :row-key="getRowKeys">
                                        <el-table-column type="selection" width="55" :reserve-selection="true" />
                                        <el-table-column prop="title" label="头像" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <el-image style="width: 50px; height: 50px"
                                                    :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                                                    fit="cover">
                                                </el-image>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>

                                </div>
                                <div style="width:50%;margin-left:10px">
                                    <el-table :data="sendusers" border v-loading="loading" height="430px"
                                        ref="configurationTable">
                                        <el-table-column prop="title" label="头像" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                  <el-image style="width: 50px; height: 50px"
                                                    :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                                                    fit="cover">
                                                </el-image>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                            <div class="u-f u-ac u-jsb ft_mr">
                                <div>
                                    <el-pagination @size-change="userhandleSizeChange"
                                        @current-change="userhandleCurrentChange" :current-page="usercurrentPage"
                                        :page-sizes="[10, 20, 30, 40]" :page-size="userpagesize"
                                        layout="total, sizes, prev, pager, next" :total="usercount">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="立即推送">
                        <el-radio v-model="push" :label="0">否</el-radio>
                        <el-radio v-model="push" :label="1">是</el-radio>
                    </el-form-item>
                    <el-form-item label="活动链接">
                        <el-input size="small" v-model="forms.url" style="max-width:500px"></el-input><span
                            style="color:red">不填则跳转至活动详情页面</span>
                    </el-form-item>


                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading='sendacloading' @click="submited('forms')" size="small">确 定
                </el-button>
                <el-button @click="dialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 查看量 -->
        <el-dialog title="已查看" width="50%" :visible.sync="lookdialoged" top="20px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <div class="ibox-content">
                    <el-table :data="looktableData" border v-loading="loading" :height="heights"
                        ref="configurationTable">
                        <el-table-column prop="user_name" label="用户名" show-overfl ow-tooltip> </el-table-column>
                        <el-table-column prop="introduction" label="头像" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <img :src="scope.row.user_avatar" alt="" width="80">
                            </template>
                        </el-table-column>
                        <el-table-column prop="create_time" label="时间" show-overflow-tooltip width="180">
                        </el-table-column>
                    </el-table>
                    <div class="u-f u-ac u-jsb ft_mr">
                        <div></div>
                        <div>
                            <el-pagination @size-change="lookhandleSizeChange" @current-change="lookhandleCurrentChange"
                                :current-page="lookcurrentPage" :page-sizes="[10, 20, 30, 40]" :page-size="lookpagesize"
                                layout="total, sizes, prev, pager, next, jumper" :total="lookcount">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="lookdialoged = false" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    export default {
        components: {
            tinymce
        },
        data() {
            return {
                sendradio: 2,
                lookdialoged: false,
                titles: '',
                loading: false,
                tableData: [],
                looktableData: [],
                lookcount: 0,
                userTableData: [],
                seleteUserTableData: [],
                currentPage: 1,
                lookcurrentPage: 1,
                pagesize: 10,
                lookpagesize: 10,
                usercurrentPage: 1,
                userpagesize: 10,
                usercount: 0,
                userkeyword: '',
                count: 0,
                heights: null,

                // 
                eid: '',
                dialoged: false,
                lb_value: '',
                lb_options: [{
                    id: 1,
                    name: '普通用户'
                }, {
                    id: 2,
                    name: '医生'
                }, {
                    id: 3,
                    name: '心理医生'
                }],
                forms: {
                    problem: '',
                    zs_value: '',
                    brief: '',
                    url: '',
                },
                rules: {
                    zs_value: [{
                        required: true,
                        message: '请填写活动名称',
                        trigger: 'blur'
                    }],
                    brief: [{
                        required: true,
                        message: '请填写活动简介',
                        trigger: 'blur'
                    }],
                    problem: [{
                        required: true,
                        message: '请填写活动内容',
                        trigger: 'blur'
                    }]
                },
                sendusers: [],
                luId: '',
                sendacloading: false,
                push: 0
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
            that.searchusers()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 220 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 220 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/SystemActivity/Acticitylist", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        keyword: this.titles,

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count

                    })
                    .catch(error => {})
            },

            searchusers() {
                let that = this
                // that.loading = true
                axios
                    .post("/admin/User/userList", {
                        page: that.usercurrentPage,
                        limit: that.userpagesize,
                        keyword: this.userkeyword,
                        customer_type: this.lb_value

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.userTableData = response.data.data.list
                        that.usercount = response.data.data.totalCount

                    })
                    .catch(error => {})
            },

            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            lookhandleSizeChange(val) {
                let that = this
                that.lookpagesize = val;
                this.getlookuser()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            lookhandleCurrentChange(val) {
                let that = this
                that.lookcurrentPage = val;
                this.getlookuser()
            },
            getRowKeys(row) {
                return row.id; // id为列表数据的唯一标识
            },
            userhandleSizeChange(val) {
                let that = this
                that.userpagesize = val;
                that.searchusers()
            },
            userhandleCurrentChange(val) {
                let that = this
                that.usercurrentPage = val;
                that.searchusers()
            },
            clear() {
                this.sendradio = 2
            },
            // 新增
            add() {
                let that = this
                this.clear()
                that.dialoged = true
                that.eid = ''
                that.forms.zs_value = ''
                that.forms.problem = ''
                that.forms.brief = ''
                that.searchusers()

            },
            // 设置
            submited() {
                let that = this
                let userids = []
                let value = 0
                if (!that.forms.zs_value) return this.$message.error('请填写标题')
                if (!that.forms.brief) return this.$message.error('请填写简介')
                if (!that.forms.problem) return this.$message.error('请填写内容')
                userids = this.sendusers.map(ele => ele.id);
                if (userids && userids.length > 0) {
                    value = userids.toString()
                }

                if (this.sendradio == 2) {

                    var params = {
                        id: that.eid,
                        author: this.user.id,
                        activity_title: that.forms.zs_value,
                        activity_content: that.forms.problem,
                        receiver: value,
                        introduction: that.forms.brief,
                        send_type: this.sendradio,
                        push: this.push,
                        url: that.forms.url,
                    }
                    var params2 = {
                        author: this.user.id,
                        activity_title: that.forms.zs_value,
                        activity_content: that.forms.problem,
                        receiver: value,
                        introduction: that.forms.brief,
                        send_type: this.sendradio,
                        push: this.push,
                        url: that.forms.url,
                    }
                } else {
                    if (!this.lb_value) {
                        this.$message.error('请选择所属类别人员')
                        return
                    }
                    var params = {
                        id: that.eid,
                        author: this.user.id,
                        activity_title: that.forms.zs_value,
                        activity_content: that.forms.problem,
                        introduction: that.forms.brief,
                        send_type: this.sendradio,
                        receiver_type: this.lb_value,
                        push: this.push,
                        url: that.forms.url,
                    }
                    var params2 = {
                        author: this.user.id,
                        activity_title: that.forms.zs_value,
                        activity_content: that.forms.problem,
                        introduction: that.forms.brief,
                        send_type: this.sendradio,
                        receiver_type: this.lb_value,
                        push: this.push,
                        url: that.forms.url,
                    }
                }
                if (this.sendradio == 2 && !this.lb_value && value == 0) {
                    this.$confirm('你未选择任何用户，这将发送给全部用户, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.subnithand(params, params2)
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                } else {
                    this.subnithand(params, params2)
                }
            },

            subnithand(params, params2) {
                if (this.eid) {
                    this.sendacloading = true
                    axios
                        .post("/admin/SystemActivity/update", params, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.dialoged = false
                                this.search()
                                this.$message("操作成功")
                            } else {
                                this.$message.error(response.data.msg)
                            }
                            this.sendacloading = false
                        })
                        .catch(error => {
                            this.sendacloading = false
                        })
                } else {
                    this.sendacloading = true
                    axios
                        .post("/admin/SystemActivity/save", params2, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.dialoged = false
                                this.$message("操作成功")
                                this.search()
                            } else {
                                this.$message.error(response.data.msg)
                            }
                            this.sendacloading = false

                        })
                        .catch(error => {
                            this.sendacloading = false
                        })
                }
            },
            handleEdit(index, row) {
                let that = this
                this.clear()
                that.dialoged = true
                that.eid = row.id
                that.forms.zs_value = row.activity_title
                that.forms.problem = row.activity_content
                that.forms.brief = row.introduction
                that.forms.url = row.url
                that.searchusers()
                this.$nextTick(() => {
                    this.$refs.configurationTables.clearSelection();

                })

            },
            handleDel(index, row) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/SystemActivity/del", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.begin()
                            }

                        })
                        .catch(error => {})

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            handleSelectionChange(val) {
                this.sendusers = val;
            },
            closedialo() {
                this.userkeyword = ''
                this.sendusers = []
                if (this.sendradio == 2) {
                    this.$nextTick(() => {
                        this.$refs.configurationTables.clearSelection();
                    })
                }
            },
            openlode(id) {
                this.lookdialoged = true
                this.luId = id
                this.getlookuser()
            },

            getlookuser() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/SystemReadRecord/historyRead", {
                        page: that.lookcurrentPage,
                        page_count: that.lookpagesize,
                        id: this.luId,
                        source: 2,

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.looktableData = response.data.data.data
                        that.lookcount = response.data.data.count

                    })
                    .catch(error => {})
            }

        },
        watch: {
            sendradio(newval, oldval) {

                if (this.sendradio == 1) {
                    this.userkeyword = ''
                    this.sendusers = []
                    this.searchusers()

                }
            }
        }

    };
</script>


<style scoped>
    .pd {
        padding: 0 10px
    }

    .editors {
        height: 300px;

    }

    .editors>>>.tox-tinymce {
        height: 300px !important;
    }

    .xq {
        color: rgb(0, 147, 206);
        cursor: pointer;
    }
</style>